<template>
    <div class="tile is-ancestor">
        <div class="tile is-vertical is-parent">
            <div class="tile is-child has-text-left">
                <h1 class="title">Account</h1>
            </div>

            <div class="tile is-child">                
                <section>
                    <!-- Info Form start -->
                    <form class="box has-background-white-ter has-text-left" data-vv-scope="info-form" 
                        @submit.prevent="validateBeforeSubmit">
                        <div class=""  style="margin-bottom: 10px">
                            <p class="subtitle is-size-4">My Information</p>
                        </div>
                        <div class="columns" >
                            <div class="column">
                                <b-field custom-class="is-size-7 has-text-grey-dark" label="Email"
                                    :type="{'is-danger': errors.has('info-form.email')}"
                                    :message="errors.first('info-form.email')">
                                    <b-input type="email" v-model="user.email" name="email" disabled />
                                </b-field>
                            </div>
                            <div class="column">
                                <b-field custom-class="is-size-7 has-text-grey-dark" label="Last name"
                                    :type="{'is-danger': errors.has('info-form.last_name')}"
                                    :message="errors.first('info-form.last_name')">
                                    <b-input v-model="user.last_name" name="last_name" v-validate="'required'" />
                                </b-field>
                            </div>
                            <div class="column">
                                <b-field custom-class="is-size-7 has-text-grey-dark" label="First name"
                                    :type="{'is-danger': errors.has('info-form.first_name')}"
                                    :message="errors.first('info-form.first_name')">
                                    <b-input v-model="user.first_name" name="first_name" v-validate="'required'" />
                                </b-field>
                            </div>
                        </div>
                        <div class="columns is-mobile">
                            <div class="column is-4 is-offset-8">
                                <button type="submit" class="button is-primary is-pulled-right"> Update Information </button>
                            </div>
                        </div>
                    </form>
                    <!-- Info Form end -->


                    <!-- Change password Form start -->
                    <form class="box has-background-white-ter has-text-left" data-vv-scope="password-form" @submit.prevent="validateBeforeSubmit">
                        <div class=""  style="margin-bottom: 10px">
                            <p class="subtitle is-size-4">Change Password</p>
                        </div>
                        <div class="columns">
                            <div class="column">
                                <b-field custom-class="is-size-7 has-text-grey-dark" label="Current password"
                                    :type="{'is-danger': errors.has('password-form.password')}"
                                    :message="errors.first('password-form.password')">
                                    <b-input type="password" v-model="user.old_password" name="old-password" v-validate="'required|min:8'" />
                                </b-field>
                            </div>
                            <div class="column">
                                <b-field custom-class="is-size-7 has-text-grey-dark" label="New password"
                                    :type="{'is-danger': errors.has('password-form.password')}"
                                    :message="errors.first('password-form.password')">
                                    <b-input type="password" v-model="user.new_password1" name="password" v-validate="'required|min:8'" />
                                </b-field>
                            </div>
                            <div class="column">
                                <b-field custom-class="is-size-7 has-text-grey-dark" label="Confirm new password"
                                    :type="{'is-danger': errors.has('password-form.confirm-password')}"
                                    :message="[{
                                        'The confirm password field is required' : errors.firstByRule('password-form.confirm-password', 'required'),
                                        'The confirm password is not valid' : errors.firstByRule('password-form.confirm-password', 'is')
                                    }]">
                                    <b-input type="password" v-model="user.new_password2" name="confirm-password"
                                        v-validate="{ required: true, is: user.new_password1 }" />
                                </b-field>
                            </div>
                        </div>
                        <div class="columns is-mobile">
                            <div class="column is-4 is-offset-8">
                                <button type="submit" class="button is-primary is-pulled-right"> Update Password </button>
                            </div>
                        </div>
                    </form>
                    <!-- Change password  Form end -->
                </section>
            </div>
        </div>
    </div>
            
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
export default {
    name: 'AccountComponent',
    data: function(){
        return {
            user: {}
        }
    },
    components: {
        
    },
    computed: {
        ...mapGetters ([
            'base_url', 'current_user'
        ])
    },
    mounted: function(){
        this.user = this.current_user
    },
    methods: {
        validateBeforeSubmit(scope) {
            this.$validator.validateAll(scope).then((result) => {
                if (result) {
                    if(scope.target.nextElementSibling)
                        this.$emit('submitEditUser', this.user)
                    else
                        this.$emit('submitEditPassword', this.user)
                }
                else {
                    this.$toast.open({
                        message: 'Form is not valid! Please check the fields',
                        type: 'is-danger',
                        position: 'is-top'
                    })
                }
            });
        }
    }
    
}
</script>

<style>
</style>
